import deepmerge from 'deepmerge';
import { unmarshaller as mediumRectangleConfig } from './configs/config-medium-rectangle-video';
import { unmarshaller as thumbnailConfig } from './configs/config-thumbnail-video';
import { unmarshaller as headerAdConfig } from './configs/config-header-ad-video';
import { unmarshaller as footerAdConfig } from './configs/config-footer-ad-video';
import { unmarshaller as interstitialConfig } from './configs/config-interstitial-video';
import { unmarshaller as optinConfig } from './configs/config-optin-video';
import { unmarshaller as defaultConfig } from './configs/config';
import { formatConfigUnmarshaller as standardBannersConfig } from './configs/standard-banners/';
import { inArticleLandscapeConfig } from './configs/config-in-article-landscape-video';
import { inArticleRevealConfig } from './configs/config-in-article-reveal-video';
import { IN_ARTICLE_LANDSCAPE, IN_ARTICLE_REVEAL } from './enums/in-article';
import { toKebabCase } from './lib/casings';
import { AD_UNIT_TYPE } from '../../common/js/adUnit';

const VIDEO_SDK3 = 'video-sdk3';

interface FormatConfigEntry {
  id: string;
  config: any;
  dirname?: string;
}

function generateCreativeConsoleSchema(
  unmarshaller: Record<string, any>
): Record<string, FormatConfigEntry> {
  const _formatConfigUnmarshaller: Record<string, FormatConfigEntry> = {};

  for (const key in unmarshaller) {
    const id = `${VIDEO_SDK3}/${key}`;
    const config = unmarshaller[key];
    const dirname = toKebabCase(key);

    _formatConfigUnmarshaller[key] = { id, config, dirname };

    if (key === 'default') {
      _formatConfigUnmarshaller[key].id = VIDEO_SDK3;
      delete _formatConfigUnmarshaller[key].dirname;
    }
  }

  return _formatConfigUnmarshaller;
}

// TODO: to remove, it seems to not be used and duplicated with the one from this file legacy/formats/video-sdk3/configs/config.js => https://jira.ogury.io/browse/SPY-14898
export const excludedMimeType = [
  'video/3gpp',
  'video/ogg',
  'video/x-flv',
  'video/quicktime'
];

export const unmarshaller: Record<string, any> = {
  [AD_UNIT_TYPE.MEDIUM_RECTANGLE]: mediumRectangleConfig,
  [AD_UNIT_TYPE.INTERSTITIAL]: deepmerge(defaultConfig, interstitialConfig),
  [AD_UNIT_TYPE.OPTIN_VIDEO]: deepmerge(defaultConfig, optinConfig),
  [AD_UNIT_TYPE.THUMBNAIL]: deepmerge(defaultConfig, thumbnailConfig),
  [AD_UNIT_TYPE.HEADER_AD]: deepmerge(defaultConfig, headerAdConfig),
  [AD_UNIT_TYPE.FOOTER_AD]: deepmerge(defaultConfig, footerAdConfig),
  [AD_UNIT_TYPE.STANDARD_BANNERS]: deepmerge(
    defaultConfig,
    standardBannersConfig
  ),
  [`${AD_UNIT_TYPE.IN_ARTICLE}/${IN_ARTICLE_LANDSCAPE}`]: deepmerge(
    defaultConfig,
    inArticleLandscapeConfig
  ),
  [`${AD_UNIT_TYPE.IN_ARTICLE}/${IN_ARTICLE_REVEAL}`]: deepmerge(
    defaultConfig,
    inArticleRevealConfig
  ),
  default: defaultConfig
};

export const formatConfigUnmarshaller = generateCreativeConsoleSchema(
  unmarshaller
);
